import request from '@/utils/request'

//企业列表分页查询
export function getCompanyLists(data) {
  return request({
    url: '/company/getCompanyLists',
    method: 'post',
    data
  })
}

//企业单个查询
export function getCompanyBYid(data) {
  return request({
    url: '/company/getCompanyBYid',
    method: 'get',
    params: data
  })
}

//删除单个企业
export function deleteCompanyId(data) {
  return request({
    url: '/company/deleteCompany',
    method: 'post',
    data
  })
}

//新增企业接口
export function saveCompanyId(data) {
  return request({
    url: '/company/save',
    method: 'post',
    data
  })
}

//编辑企业
export function updataCompanyId(data) {
  return request({
    url: '/company/update',
    method: 'post',
    data
  })
}

// 模糊查询公司全称
export function getCompanyNamesLogo(data) {
  return request({
    url: '/company/getCompanyNamesLogo',
    method: 'post',
    params:data
  })
}

// 新增企业文件 
export function addSaveArchivesCenter(data) {
  return request({
    url: '/company/saveArchivesCenter',
    method: 'post',
    data
  })
}

// 修改企业文件 
export function updateArchivesCenter(data) {
  return request({
    url: '/company/updateArchivesCenter',
    method: 'post',
    data
  })
}

// 删除文件
export function deleteArchivesCenter(data) {
  return request({
    url: '/company/deleteArchivesCenter',
    method: 'post',
    data
  })
}

// 文件一览
export function getArchivesCenter(data) {
  return request({
    url: '/company/getArchivesCenter',
    method: 'post',
    data
  })
}